//请自行添加语言资源
const shipTo = {
  areaName:'区域名称',
  shiptoName:'送达方名称',
  customerNo:'客户编号',
  city:'城市',
  areaCode:'区域编号',
  postcode:'邮政编码',
  delStatus:'删除标记',
  soldtoNo:'售达方编号',
  frozenState:'冻结状态',
  shiptoNo:'送达方编号',
  district:'街道',
  tel:'电话',
  fax:'传真',
  shiptoNoTemp: '送达方编号',
  msg:{
  }
};
export default shipTo



// WEBPACK FOOTER //
// ./src/page/md/shipTo/lang/shipTo.zh.js